var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.5556,
    height: 25,
    transform: "translate(0.664062)",
    fill: "#C5FF3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5111 15.5H13.1929V10.9858H11.6536V10.11C12.0598 10.0919 12.3442 10.0649 12.5067 10.0288C12.7656 9.97157 12.9762 9.85721 13.1387 9.68567C13.2501 9.5683 13.3344 9.41181 13.3915 9.21619C13.4246 9.09882 13.4412 9.01154 13.4412 8.95436H14.5111V15.5ZM16.7366 14.1548H18.1044V15.5H16.7366V14.1548ZM21.1966 12.2498C21.0401 12.2498 20.9047 12.2693 20.7904 12.3084C20.5887 12.3807 20.4367 12.5146 20.3344 12.7102L19.1788 12.656L19.6392 9.04013H23.2461V10.1326H20.5692L20.3344 11.5636C20.533 11.4342 20.688 11.3484 20.7994 11.3063C20.986 11.2371 21.2132 11.2025 21.481 11.2025C22.0227 11.2025 22.4952 11.3845 22.8985 11.7487C23.3018 12.1128 23.5034 12.6425 23.5034 13.3377C23.5034 13.9426 23.3093 14.4828 22.9211 14.9583C22.5329 15.4338 21.952 15.6715 21.1786 15.6715C20.5556 15.6715 20.044 15.5045 19.6437 15.1705C19.2435 14.8364 19.0208 14.3624 18.9756 13.7485H20.2577C20.3088 14.0284 20.4066 14.245 20.5511 14.3985C20.6956 14.549 20.9062 14.6242 21.1831 14.6242C21.5021 14.6242 21.7444 14.5129 21.9099 14.2902C22.0784 14.0645 22.1627 13.7816 22.1627 13.4415C22.1627 13.1075 22.0844 12.8261 21.9279 12.5973C21.7715 12.3656 21.5277 12.2498 21.1966 12.2498Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/1.5.71d9bb8c85ba644f0af345ba693d0d26.svg";
export { ForwardRef as ReactComponent };